import React from 'react';
import PropTypes from 'prop-types';
import FlashMessages from '../FlashMessages';
import CookieConsent from '../CookieConsent';
import SiteLoader from '../SiteLoader';
import CheckoutHeader from '../MainCheckout/CheckoutHeader';
import './CheckoutPage.scss';

const CheckoutPage = props => (
  <div
    className="app-checkout">
    <CookieConsent />
    <CheckoutHeader />
    <FlashMessages {...props} />
    {props.children}
    <SiteLoader />
    <div id="modal-container" />
  </div>
);

CheckoutPage.propTypes = {
  children: PropTypes.node,
};

export default CheckoutPage;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CheckoutPage/CheckoutPage.js